// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default (src) => {
    for (let opt of ["email", "fax", "upload", "dropbox", "google drive", "onedrive", "sharepoint", "filled"])
        if (src.toLowerCase().includes(opt === "filled" ? "form" : opt))
            return "https://static.stax.ai/images/icons/" + opt + ".png";
}